import TemplateView from '../../../../TemplateView'
import {trim} from '../../../../atUtils'
import {isValueEmpty} from './validationUtils'
import messageResource from '../../../../messageResource'
import {MAX_RATE} from 'constants'
import {isEnterPressed, isEscapePressed} from '../../../../atBrowserUtils'
import NumberFormatter from '../../../../number_formatter'
import {getInstance as getModalAlert} from '../../UserPanelModalAlert'
import {ModalAlertPointerPosition} from '../../../../components/modalAlert/constants'
import {UserRatesErrors} from './constants'
import FloatNumberValidator from '../../../../administration/userManagement/ratesEditor/FloatNumberValidator'

const numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)

export default class RateCell extends TemplateView {
    constructor({
        readOnly = false,
        scrollTo = () => {},
        onChangeCb = () => {},
        rollbackChanges = () => {},
    }) {
        super()

        this.params = {
            readOnly,
            scrollTo,
        }

        this.callbacks = {
            onChangeCb,
            rollbackChanges,
        }

        this.state = {
            rate: null,
            isEmptyValid: true,
            error: null,
            needShowWarning: false
        }

        this.onAnyStatePropertyChanged(['rate'], state => this._update(state))
        this.onStatePropertyChanged('error', error => this._updateError(error))
        this.onStatePropertyBecameTrue('needShowWarning', () => this._showWarning(this.state.rate))
    }

    templateHtml() {
        return '<div class="rateCell">' +
               '    <input type="text" placeholder="<%=placeholder%>" maxlength="8"/>' +
               '    <div class="clearButton"></div>' +
               '    <div class="rateLabel"></div>' +
               '</div>'
    }

    templateModel() {
        return {
            placeholder: `0${window.SystemSettings.decimalSeparator}00`
        }
    }

    afterRender() {
        this.$input = this.find('input')
        this.$rateLabel = this.find('.rateLabel')
        this.$clearButton = this.find('.clearButton')

        if (!this.params.readOnly) {
            this.$input
                .on('input', () => this._handleInputChange())
                .on('blur', () => this._handleInputBlur())
                .on('focus', () => this._handleInputChange())
                .on('keydown', (e) => this._handleKeyDown(e))

            this.$clearButton
                .mousedown(e => e.preventDefault())

            this.$clearButton.click(() => {
                if(!this.params.readOnly)
                    this.$input.val('').focus()
            })
        }

        this.$input.toggle(!this.params.readOnly)
        this.$rateLabel.toggle(this.params.readOnly)
    }

    _update(state) {
        const rate = state.rate

        if (!this.params.readOnly) {
            this.$input.val(FloatNumberValidator.getInstance().isValidNumber(rate) ? numberFormatter.format(rate) : rate)
        } else {
            this.$rateLabel.text(FloatNumberValidator.getInstance().isValidNumber(rate) ? numberFormatter.format(rate) : rate)
        }

        this._updateError(state.error)
    }

    _updateError(error) {
        const isValid = error === null
        this.getEl().toggleClass('invalid', !isValid)

        if (!isValid) {
            let msg = error === UserRatesErrors.RATE_EMPTY ? messageResource.getMessage('user.add_edit.js.rates_editor.empty_rate') :
                      error === UserRatesErrors.RATE_INVALID ? messageResource.getMessage('user.add_edit.js.rates_editor.invalid_rate', [MAX_RATE]) : ""
            this.$input.attr('title', msg)
        }
    }

    _handleInputChange() {
        const value = trim(this.$input.val())
        this.$clearButton.toggle(value.length > 0)
    }

    _handleInputBlur() {
        this.$clearButton.hide()
        this._handleRateChanged()
    }

    _handleKeyDown(e) {
        if (isEscapePressed(e) || isEnterPressed(e)) {
            this._handleInputBlur()
            e.stopPropagation()
        }
    }

    _handleRateChanged() {
        const value = numberFormatter.normalize(trim(this.$input.val()))
        this.$input.val(value)

        if (value.length === 0 && isValueEmpty(this.state.rate) || value == this.state.rate) {
            this.$input.val(numberFormatter.format(value))
            return
        }

        const isValid = value.length > 0 && FloatNumberValidator.getInstance().isValidNumber(value)
        this.callbacks.onChangeCb(isValid ? Number(numberFormatter.normalize(value)) : value)
    }

    _showWarning(value) {
        let msg = value.length === 0 ? messageResource.getMessage('user.add_edit.js.rates_editor.empty_rate')
                                     : messageResource.getMessage('user.add_edit.js.rates_editor.invalid_rate', [MAX_RATE])
        msg = msg + '\n' + messageResource.getMessage('rates.editor.modifications_will_be_discarded')

        this.params.scrollTo(this.getEl())

        getModalAlert().setState({
            text: msg,
            pointerPosition: ModalAlertPointerPosition.CENTER
        }).showAt(this.getEl(), () => {
            this.callbacks.rollbackChanges()
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/RateCell.js